import React, { useEffect, useState } from 'react';
import { Box, Button, TextField, Typography, MenuItem, CircularProgress } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../axiosInstance';
import Profile from '../../components/Profile';
import Notification from '../../components/Notification';

const EditBookPage = () => {
  const { bookId } = useParams();
  const [collegeId, setCollegeId] = useState(null);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    bookTitle: '',
    bookDescription: '',
    authorName: '',
    publisherName: '',
    publicationYear: '',
    publisherEdition: '',
    ISBN: '',
    bookType: '',
    bookLanguage: '',
    coverImageURL: '',
    pdfURL: '',
    courseId: '',
    subjectId: '',
    semester: ''
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const semesters = [1, 2, 3, 4, 5, 6, 7, 8];


  

  useEffect(() => {
    const fetchBook = async () => {
      try {
        const bookRes = await axios.get(`https://backend.scholarkart.in/api/books/${bookId}`);
        const book = bookRes.data;
  
        const normalizeSemester = (value) => {
          const romanToArabic = {
            I: '1', II: '2', III: '3', IV: '4', V: '5',
            VI: '6', VII: '7', VIII: '8'
          };
          if (!value) return '';
          return romanToArabic[value.toUpperCase()] || value;
        };
  
        const courseRes = await axios.get('https://backend.scholarkart.in/api/courses');
        setCourses(courseRes.data);
  
        const courseId = book.courseDetails?.courseId || '';
        const subjectId = book.courseDetails?.subjectId || '';
  
        if (courseId) {
          const subjectRes = await axios.get(`https://backend.scholarkart.in/api/subjects?courseId=${courseId}`);
          setSubjects(subjectRes.data);
        }
  
        setFormData({
          bookTitle: book.bookTitle || '',
          bookDescription: book.bookDescription || '',
          authorName: book.authorName || '',
          publisherName: book.publisherName || '',
          publicationYear: book.publicationYear || '',
          publisherEdition: book.publisherEdition || '',
          ISBN: book.ISBN || '',
          bookType: book.bookType || '',
          bookLanguage: book.bookLanguage || '',
          coverImageURL: book.coverImageURL || '',
          pdfURL: book.pdfURL || '',
          courseId,
          subjectId,
          semester: normalizeSemester(book.courseDetails?.semester)
        });
  
      } catch (err) {
        console.error('Error fetching book:', err);
        setError('Failed to fetch book details.');
      } finally {
        setLoading(false);
      }
    };
  
    fetchBook();
  }, [bookId]);

  


  useEffect(() => {
  if (formData.courseId) {
    axios.get(`https://backend.scholarkart.in/api/subjects?courseId=${formData.courseId}`)
      .then((res) => setSubjects(res.data));
  } else {
    setSubjects([]);
  }
}, [formData.courseId]);

useEffect(() => {
  if (subjects.length > 0 && !subjects.find(s => s._id === formData.subjectId)) {
    setFormData(prev => ({ ...prev, subjectId: '' }));
  }
}, [subjects]);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Build nested courseDetails only if values exist
    const courseDetails = {};
    if (formData.courseId) courseDetails.courseId = formData.courseId;
    if (formData.subjectId) courseDetails.subjectId = formData.subjectId;
    if (formData.semester) courseDetails.semester = formData.semester;
  
    const payload = {
      ...formData,
      courseDetails
    };
  
    // Remove the flat versions to avoid confusion in backend
    delete payload.courseId;
    delete payload.subjectId;
    delete payload.semester;
  
    try {
      await axios.put(`https://backend.scholarkart.in/api/books/${bookId}`, payload);
      navigate('/librarymanagement');
    } catch (err) {
      console.error('Error updating book:', err);
    }
  };
  

  if (loading) {
    return (
      <Box p={4} textAlign="center">
        <CircularProgress />
        <Typography variant="body2" mt={2}>Loading book details...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={4} textAlign="center">
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <main className="flex-grow p-1">
    <div className="flex justify-between items-center relative bg-white p-4 rounded-lg shadow-md">

        <div className="relative w-full max-w-lg">

        </div>

      <div className="flex items-center space-x-4 relative">
        <Notification />
        <Profile />
      </div>
    </div>

    <Box p={4}>
      <Typography variant="h4" mb={4}>Edit Book</Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <Box display="grid" gridTemplateColumns="repeat(auto-fit, minmax(300px, 1fr))" gap={2}>
          <TextField label="Title" name="bookTitle" value={formData.bookTitle} onChange={handleChange} required />
          <TextField label="Author" name="authorName" value={formData.authorName} onChange={handleChange} required />
          <TextField label="Publisher" name="publisherName" value={formData.publisherName} onChange={handleChange} />
          <TextField label="Publication Year" name="publicationYear" value={formData.publicationYear} onChange={handleChange} />
          <TextField label="Edition" name="publisherEdition" value={formData.publisherEdition} onChange={handleChange} />
          <TextField label="ISBN" name="ISBN" value={formData.ISBN} onChange={handleChange} />
          <TextField select label="Book Type" name="bookType" value={formData.bookType} onChange={handleChange} required>
            <MenuItem value="Textbook">Textbook</MenuItem>
            <MenuItem value="Reference Book">Reference Book</MenuItem>
          </TextField>
          <TextField select label="Language" name="bookLanguage" value={formData.bookLanguage} onChange={handleChange} required>
            <MenuItem value="English">English</MenuItem>
            <MenuItem value="Hindi">Hindi</MenuItem>
            <MenuItem value="Kannada">Kannada</MenuItem>
            <MenuItem value="Sanskrit">Sanskrit</MenuItem>
            <MenuItem value="Others">Others</MenuItem>
          </TextField>
          <TextField label="Cover Image URL" name="coverImageURL" value={formData.coverImageURL} onChange={handleChange} />
          <TextField label="PDF URL" name="pdfURL" value={formData.pdfURL} onChange={handleChange} />
          <TextField
            select
            label="Course"
            name="courseId"
            value={formData.courseId}
            onChange={handleChange}
          >
            {courses.map(course => (
              <MenuItem key={course._id} value={course._id}>{course.courseName}</MenuItem>
            ))}
          </TextField>
          {subjects.length > 0 && (
            <TextField
              select
              label="Subject"
              name="subjectId"
              value={formData.subjectId}
              onChange={handleChange}
            >
              {subjects.map(subject => (
                <MenuItem key={subject._id} value={subject._id}>{subject.subjectName}</MenuItem>
              ))}
            </TextField>
          )}
          <TextField
            select
            label="Semester"
            name="semester"
            value={formData.semester}
            onChange={handleChange}
          >
            {semesters.map((s) => (
              <MenuItem key={s} value={s}>{`Semester ${s}`}</MenuItem>
            ))}
          </TextField>
        </Box>
        <Box mt={3}>
          <Button type="submit" variant="contained" color="primary">Update Book</Button>
        </Box>
      </Box>

    </Box>
    </main>
  );
};

export default EditBookPage;
